module.exports = __webpack_public_path__ + "img/thumbnail_LogoMAAE.5d81b4ae.jpg";